import { IAction } from 'src/interfaces';
import { authActionTypes, workspacesTypes } from '../types';
import { TWorkspacesReducer } from 'src/interfaces/workspacesReduxShapes';

const initialState: TWorkspacesReducer = {
  companyWorkspaces: [],
  userWorkspaces: [],
  isLoading: true,
  selected: null,
  accesses: { isLoading: true, list: [], workspaceName: '' }
};

export default (state = initialState, { type, payload }: IAction): TWorkspacesReducer => {
  switch (type) {
    case workspacesTypes.PUT_COMPANY_WORKSPACES:
      return { ...state, companyWorkspaces: payload, isLoading: false };

    case workspacesTypes.PUT_USER_WORKSPACES:
      return { ...state, userWorkspaces: payload, isLoading: false };

    case workspacesTypes.PUT_COMPANY_WORKSPACES_ACCESS: {
      const workspaceName = state.companyWorkspaces.find((w) => w.id === payload.workspaceId)?.name || '';

      return { ...state, accesses: { isLoading: false, list: payload.list, workspaceName } };
    }

    case workspacesTypes.SET_SELECTED_WORKSPACE:
      return { ...state, selected: payload };

    case authActionTypes.SIGN_OUT:
      return initialState;

    default:
      return state;
  }
};
